module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_schweiz_de-ce2aab00f00c412c8e02dad5f1abdd95.svg";